var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkles1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5111 22.9998C9.57852 23.0121 8.75004 22.3505 8.47636 21.375L6.78 15.5715L1.45866 13.6236C0.577398 13.3013 -0.0122862 12.3927 0.000194354 11.3762C0.0126747 10.3597 0.624456 9.46863 1.51331 9.17238L6.79262 7.40845L8.57095 1.5969C8.84292 0.61503 9.68773 -0.0410471 10.6247 0.00199883C11.5574 0.00338174 12.3778 0.677134 12.6395 1.65669L14.2496 7.4234L19.5363 9.27472C20.4107 9.59561 21 10.4918 21 11.5009C21 12.51 20.4107 13.4062 19.5363 13.7271L14.2402 15.5807L12.5459 21.375C12.2723 22.3505 11.4438 23.0121 10.5111 22.9998ZM10.6289 1.47083L8.6193 8.69978C8.51179 9.05265 8.25492 9.32684 7.92982 9.43571L1.24144 11.3721L7.95084 13.5765C8.26862 13.6923 8.5169 13.9669 8.6193 14.3158L10.4796 21.5322L12.403 14.3158C12.5065 13.9616 12.7602 13.684 13.0841 13.5707L19.7819 11.5366C20.675 11.5343 19.7964 11.5308 19.8029 11.5262L13.0841 9.43111C12.7555 9.31615 12.4993 9.03208 12.3988 8.67103L10.6289 1.47083Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles1);
export default __webpack_public_path__ + "static/media/sparkles1.c24855f47855e29f8ac5923294747cd1.svg";
export { ForwardRef as ReactComponent };